// extracted by mini-css-extract-plugin
export default {"container":"k57gOu1X","list":"kyAwtj9a"};